import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/styles.css';
import './assets/js/scripts';

createApp(App).mount('#app')
